export default "__VITE_ASSET__TG_17fF4__"